module.exports = __webpack_public_path__ + "static/media/bygning.b336e205.jpg";